// extracted by mini-css-extract-plugin
export default {"usdCoinUsdc":"USDCoinUSDC_usdCoinUsdc__+fZ+G"};